import { SVGProps, Ref, forwardRef } from 'react';

export const PlayCircleOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M5.715 4.796c.38-.308.917-.036 1.988.506l1.541.78c1.615.816 2.423 1.225 2.423 1.918s-.808 1.102-2.423 1.919l-1.54.78c-1.073.542-1.608.813-1.99.504-.38-.308-.381-1.013-.381-2.424V7.221c0-1.41 0-2.117.382-2.425"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.517.51c5.055.217 6.866 3.626 6.977 7.138L15.5 8c0 3.75-1.875 7.5-7.5 7.5S.5 11.75.5 8l.006-.352C.62 4.02 2.55.5 8 .5zM8 1.9c-2.476 0-3.925.81-4.784 1.84C2.319 4.816 1.9 6.333 1.9 8s.42 3.184 1.316 4.26C4.076 13.29 5.524 14.1 8 14.1s3.925-.81 4.784-1.84C13.681 11.184 14.1 9.667 14.1 8s-.42-3.184-1.316-4.26C11.924 2.71 10.476 1.9 8 1.9"
                fill="currentColor"
            />
        </g>
    </svg>
));
PlayCircleOutlinedSize16Glyph.displayName = 'PlayCircleOutlinedSize16Glyph';
